import type { AxiosError } from 'axios';
import type { ApiError } from '@pms/shared';

/** Every tracker query key starts here, so Refresh can invalidate the whole page at once. */
export const TRACKER_KEY = ['tracker'] as const;

export const trackerKeys = {
  health: [...TRACKER_KEY, 'health'] as const,
  stats: [...TRACKER_KEY, 'stats'] as const,
  users: [...TRACKER_KEY, 'users'] as const,
  activity: [...TRACKER_KEY, 'activity'] as const,
  images: [...TRACKER_KEY, 'images'] as const,
};

/** Poll cadence for presence + stats while the page is on Live. */
export const TRACKER_LIVE_INTERVAL_MS = 30_000;

/** Backend codes a retry cannot fix: the secret is missing, or the tracker refused it. */
const SETUP_ERROR_CODES = new Set(['TRACKER_NOT_CONFIGURED', 'TRACKER_AUTH_FAILED']);

export function trackerErrorCode(e: unknown): string | undefined {
  // React Query reports "no error" as null — only an object can carry an Axios response.
  if (!e || typeof e !== 'object') return undefined;
  return (e as AxiosError<ApiError>).response?.data?.error?.code;
}

export function isTrackerSetupError(e: unknown): boolean {
  const code = trackerErrorCode(e);
  return code !== undefined && SETUP_ERROR_CODES.has(code);
}

export const retryUnlessSetupError = (count: number, error: unknown) => !isTrackerSetupError(error) && count < 2;
